import { Spacing } from '@billy/design-system'
import { StyleSheet } from '@react-pdf/renderer'

export const profitAndLossTableHeaderStyles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    gap: Spacing.S8,
  },
  columnLabelContainer: {
    flexGrow: 1,
    flexBasis: 0,
    alignItems: 'flex-end',
  },
  periodLabelContainer: {
    alignSelf: 'flex-end',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: Spacing.S4,
    textAlign: 'center',
  },
  visibleColumnsContainer: {
    flexDirection: 'row',
    width: '100%',
    gap: Spacing.S8,
  },
})
